<section class="two-columns-panel" *ngIf="data" #panelEl>
	<div *ngIf="data.topWave.value === true"><top-wave></top-wave></div>
	<div class="two-columns-panel__content"
			 [ngStyle]="{'padding-top' : data.topWave.value ? '115px' : '45px',
									 'padding-bottom' : data.bottomWave.value ? '150px' : '45px'}">

		<div>
			<h2 *ngIf="data.title" class="two-columns-panel__title" #titleEl>{{ data.title.value }}</h2>
			<h3 *ngIf="data.subtitle" class="two-columns-panel__subtitle" #subtitleEl>{{ data.subtitle.value }}</h3>
		</div>
		<div class="two-columns-panel__wrapper"
				 [ngClass]="{'two-columns-panel__align-items' : this.data.alignItems.value === true}"
				 #wrapperEl>
			<div #leftEl class="two-columns-panel__wrapper--item rte" *ngIf="data.descriptionLeft" [innerHTML]="strLeft"></div>
			<div #rightEl class="two-columns-panel__wrapper--item rte" *ngIf="data.descriptionRight" [innerHTML]="strRight"></div>
		</div>
		<div class="two-columns-panel__link" *ngIf="data.links?.value">
			<app-bg-button *ngFor="let link of data.links.value"
										 class="two-columns-panel__button"
										 [buttonColor]="link.color.value"
										 [data]="link.link.value"></app-bg-button>
		</div>
	</div>
	<div *ngIf="data.bottomWave.value === true"><bottom-wave></bottom-wave></div>
</section>
